import {Component, OnInit, HostListener} from '@angular/core';
import {DataProviderService, IReferenceProject, ReferenceProjectStyle} from '../shared/data-provider.service';
import {IList} from 'linq-collections/build/src/Collections';
import {WindowRefService} from '../shared/window-ref-service.service';
import {BrowserDetectorService} from '../shared/browser-detector.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-portfolio',
  templateUrl: './portfolio.component.html',
  styleUrls: ['./portfolio.component.scss']
})
export class PortfolioComponent implements OnInit {

  referenceProjects: IList<IReferenceProject>;
  url: string = 'assets/json/referenceProjects.json';
  urlHu: string = 'assets/json/referenceProjectsHu.json';

  constructor(
    private _dataProviderService: DataProviderService,
    private translateService: TranslateService,
    private windowRef: WindowRefService
  ) {
  }


  ngOnInit(): void {
    this.translateService.onLangChange.subscribe(
      newLang => {
        if (newLang.lang === 'hu') {
          this._dataProviderService.getReferenceProjects(this.urlHu)
            .subscribe(
              referenceProjects => {
                this.referenceProjects = referenceProjects;
              },
              error => console.log(error)
            );
        }
        if (newLang.lang === 'en') {
          this._dataProviderService.getReferenceProjects(this.url)
            .subscribe(
              referenceProjects => {
                this.referenceProjects = referenceProjects;
              },
              error => console.log(error)
            );
        }
      }
    );
    this._dataProviderService.getReferenceProjects(this.url)
      .subscribe(
        referenceProjects => this.referenceProjects = referenceProjects,
        error => console.log(error) // TODO show on UI
      );
  }

  //#region showCount methods
  get showCount(): number {
    return this._showCountMultiplier * this._showCountIncrease;
  }

  private _showCountMultiplier: number = 1;
  private _showCountIncrease: number = 3;

  @HostListener('window:load')
  @HostListener('window:resize')
  updateShowCountIncrease() {
    if (!this.windowRef.nativeWindow) {
      return;
    }
    let windowWidth = this.windowRef.nativeWindow.innerWidth;
    this._showCountIncrease = this._calcShowCountIncrease(windowWidth);
    // console.log("_showCountIncrease: " + this._showCountIncrease)
  }

  private _calcShowCountIncrease = (windowWidth: number): number => {
    if (windowWidth >= 992) {
      return 6;
    }
    if (windowWidth >= 768) {
      return 4;
    }
    if (windowWidth < 768) {
      return 3;
    }

    console.warn('Could not calculate ShowCount-Increase');
    return 6;
  }

  increaseShowCount() {
    this._showCountMultiplier++;
  }

  //#endregion showCount

  isDesktopAppStyle = (referenceProject: IReferenceProject): boolean => {
    return referenceProject.style === ReferenceProjectStyle.desktopApp;
  }
  isLogoStyle = (referenceProject: IReferenceProject): boolean => {
    return referenceProject.style === ReferenceProjectStyle.companyLogo;
  }
}



// WEBPACK FOOTER //
// C:/Projects/dod/companyintroduction/src/app/portfolio/portfolio.component.ts